var map = {
	"./fr/csu.yml": 152,
	"./fr/faq.yml": 153,
	"./fr/hos.yml": 154,
	"./fr/hos2.yml": 155,
	"./fr/main.yml": 34,
	"./fr/news.yml": 156,
	"./fr/rgpd.yml": 157,
	"./fr/sfs.yml": 158
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 151;